import Vue from "vue";
import Vuex from "vuex";
import User from "./User.js";
import Settings from "./Settings.js";
import Surveys from "./Surveys.js";
import Helpers from "./Helpers.js";
import Main from "./Main.js";
import Admin from "./Admin.js";
import VuexPersistence from "vuex-persist";
import sessions from "./sessions";
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  modules: ["User", "Surveys", "Main", "Helpers"],
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Main,
    User,
    Settings,
    Surveys,
    Helpers,
    sessions,
    Admin,
  },
  plugins: [vuexLocal.plugin],
});
